<template>
  <div class="contract-information-page" v-loading.fullscreen.lock="fullscreenLoading">
    <Title currentPageTitle="添加合同信息"></Title>
    <!-- 合同信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">合同信息</p>
      <el-row :gutter="24">
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red"> </span>客户名称：</div>
          <el-select
            filterable
            clearable
            v-model="customerGuid"
            @change="tenantChange"
            class="contract-base-content"
            placeholder="请选择"
          >
            <el-option
              v-for="item in tenantList"
              :key="item.tenantGuid"
              :label="item.tenantName"
              :value="item.tenantGuid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>合同类型：</div>
          <el-select 
            clearable 
            v-model="formData.contractType" 
            class="contract-base-content" 
            placeholder="请选择" 
            @change="onChangeContractType"
          >
            <el-option
              v-for="item in getCodeListByKey('合同类型')"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12" v-if="formData.contractCode">
          <div class="contract-base-title"><span class="fontC-red">*</span>合同编码：</div>
          <el-input
            disabled
            v-model.trim="formData.contractCode"
            class="contract-base-content"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>合同名称：</div>
          <el-input
            v-model.trim="formData.contractName"
            class="contract-base-content"
            placeholder="请输入"
            clearable
            maxlength="50"
          ></el-input>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red"> </span>运营经理：</div>
          <el-input
            v-model.trim="formData.projectManagerName"
            class="contract-base-content"
            placeholder="请选择"
            maxlength="20"
            @focus="addPeople"
          ></el-input>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>签约时间：</div>
          <el-date-picker
            class="contract-base-content"
            @change="changeDate(true)"
            v-model="formData.signDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>合同有效期至：</div>
          <el-date-picker
            class="contract-base-content"
            @change="changeDate(false)"
            value-format="yyyy-MM-dd"
            v-model="formData.validityDate"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>甲方名称：</div>
          <el-input
            v-if="customerGuid"
            disabled
            value-format="yyyy-MM-dd"
            v-model.trim="formData.tenantName"
            class="contract-base-content"
            placeholder="请选择"
            clearable
          ></el-input>
          <el-select
            v-else
            filterable
            clearable
            v-model="formData.tenantGuid"
            class="contract-base-content"
            placeholder="请选择"
            @change="customerChange"
          >
            <el-option
              v-for="item in serviceTenantDataList"
              :key="item.guid"
              :label="item.tenantName"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>乙方名称：</div>
          <el-select
            filterable
            clearable
            default-first-option
            v-model="formData.serviceTenantGuid"
            @change="serviceTenantChange"
            class="contract-base-content"
            placeholder="请选择"
          >
            <el-option v-for="item in serviceTenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>公司类型：</div>
          <el-select
            :disabled="customerGuid ? true : false"
            v-model="formData.enterpriseCate"
            class="contract-base-content"
            placeholder="请选择"
          >
            <el-option
              v-for="item in getCodeListByKey('平台企业类型')"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>业务类型：</div>
          <el-select
            v-model="formData.contractContentType"
            @change="contractContentTypeChange"
            class="contract-base-content"
            placeholder="请选择"
          >
            <el-option
              v-for="item in contractContentTypeOptions"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>业务类型内容：</div>
          <el-select
            v-model="formData.contractContent"
            class="contract-base-content"
            placeholder="请选择"
            @focus="contractContentTypeFocus"
          >
            <el-option
              v-for="item in getCodeListByKey(
                formData.contractContentType == 1
                  ? '业务收入类型'
                  : formData.contractContentType == 2
                  ? '业务支出类型'
                  : [],
              )"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red"> </span>合同金额(元)：</div>
          <el-input
            v-model.trim="formData.contractMoney"
            onkeyup="value=value.replace(/[^\d.]/g, '')"
            maxlength="12"
            class="contract-base-content"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>发票方式：</div>
          <el-select v-model="formData.invoiceMode" class="contract-base-content" placeholder="请选择">
            <el-option v-for="item in invoiceModeOptions" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>结算依据：</div>
          <el-select v-model="formData.balanceBasis" class="contract-base-content" placeholder="请选择">
            <el-option v-for="item in balanceBasisOptions" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>维保条件：</div>
          <el-select v-model="formData.maintainCondition" class="contract-base-content" placeholder="请选择">
            <el-option
              v-for="item in getCodeListByKey('维保条件')"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>任务价格是否含税：</div>
          <el-radio-group v-model="formData.isContainTax" class="contract-base-content">
            <el-radio label="Y">是</el-radio>
            <el-radio label="N">否</el-radio>
          </el-radio-group>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>是否垫资：</div>
          <el-radio-group v-model="formData.isAdvanceMoney" class="contract-base-content">
            <el-radio label="Y">是</el-radio>
            <el-radio label="N">否</el-radio>
          </el-radio-group>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>是否需要邮寄：</div>
          <el-radio-group @change="formData.receiveName = null; formData.receiveMobile = null; formData.mailAddress = null;" v-model="formData.isMail" class="contract-base-content">
            <el-radio label="Y">是</el-radio>
            <el-radio label="N">否</el-radio>
          </el-radio-group>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>是否补充协议：</div>
          <el-radio-group v-model="formData.isSupplementAgreement" class="contract-base-content">
            <el-radio label="Y">是</el-radio>
            <el-radio label="N">否</el-radio>
          </el-radio-group>
        </el-col>
        <el-col :span="12" v-if="formData.isMail=='Y'">
          <div class="contract-base-title"><span class="fontC-red">*</span>收件人姓名：</div>
          <el-input
            v-model.trim="formData.receiveName"
            class="contract-base-content"
            placeholder="请输入"
            clearable
            maxlength="50"
          ></el-input>
        </el-col>
        <el-col :span="12" v-if="formData.isMail=='Y'">
          <div class="contract-base-title"><span class="fontC-red">*</span>收件人电话：</div>
          <el-input
            v-model.trim="formData.receiveMobile"
            @input="formData.receiveMobile = formData.receiveMobile.replace(/[^\d\-\d]/g, '')"
            class="contract-base-content"
            placeholder="请输入"
            clearable
            maxlength="20"
          ></el-input>
        </el-col>
        <el-col :span="12" v-if="formData.isMail=='Y'">
          <div class="contract-base-title"><span class="fontC-red">*</span>邮寄地址：</div>
          <el-input
            type="textarea"
            v-model.trim="formData.mailAddress"
            maxlength="100"
            :rows="3"
            resize="none"
            class="contract-base-content"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
        
      </el-row>
    </div>
    <!-- 合同附件 -->
    <div class="contract-base-box">
      <p class="contract-base-name">合同附件</p>
      <el-row :gutter="24" class="mb20">
        <el-col :span="24">
          <div class="contract-base-title"><span class="fontC-red">*</span>合同附件：</div>
          <div>
            <el-upload
              class="upload-demo t-left"
              action="#"
              multiple
              :limit="5"
              accept=".pdf,.docx,.doc"
              :on-exceed="handleExceed"
              :on-remove="handleFileRemove"
              :http-request="uploadFile"
              :file-list="fileList"
              :beforeUpload="beforeAvatarUpload"
            >
              <div class="import-btn-tips">
                <el-button size="mini" icon="el-icon-my-import" style="margin-bottom: 0" type="importNew"
                  >导入文件</el-button
                >
                <div class="import-step-tip">支持.pdf,.docx,.doc文件，单个文件不得大于20M</div>
                <!-- <div slot="tip" class="el-upload__tip">支持.pdf,.docx,.doc文件，单个文件不得大于20M</div> -->
              </div>
              
            </el-upload>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="contract-base-title"><span class="fontC-red">*</span>合同重点内容说明：</div>
            <el-input
              class="w75f"
              type="textarea"
              :rows="5"
              show-word-limit
              maxlength="500"
              placeholder="填写与标准合同的不同之处或者合同需要关注的信息"
              v-model="formData.importantContent"
              ></el-input>
          
        </el-col>
      </el-row>
    </div>
    <!-- 产品信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">产品信息</p>
      <el-row :gutter="24" class="mb20">
        <el-col :span="24">
          <div class="contract-base-title"><span class="fontC-red">*</span>签约产品：</div>
          <el-select v-model="contractProductList" filterable multiple class="w75f" placeholder="请选择">
            <el-option
              v-for="item in getCodeListByKey('传世产品线')"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>
    <!-- 付款信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">付款信息</p>
      <el-row :gutter="24" class="mb20">
        <el-col :span="24">
          <!-- 1月度 2季度 3年度 4进度 -->
          <div class="contract-base-title"><span class="fontC-red">*</span>付款方式：</div>
          <el-select
            v-model="formData.payType"
            @change="changePayType"
            class="contract-base-content"
            placeholder="请选择"
          >
            <el-option
              v-for="item in getCodeListByKey('付款方式')"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <!-- 方式为进度时  -->
        <template v-if="formData.payType == '4'">
          <el-col  :span="24" v-for="(item, index) in payTypeJsonList" :key="index">
            <div class="contract-base-title"><span class="fontC-red">*</span>回款比例(%)：</div>
            <div>
              <el-select
                v-model="item.selectType"
                style="width: 150px; margin-right: 13px"
                placeholder="请选择"
                @change="changeCheckRepeat(1, item.selectType, 'selectType', index)"
              >
                <el-option
                  v-for="item in getCodeListByKey('费用类型')"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-input
                style="width: 150px"
                onkeyup="value=value.replace(/[^\d.]/g, '')"
                maxlength="12"
                v-model.trim="item.selectValue"
                placeholder="请输入"
                clearable
              ></el-input>
              <span class="txt-color mr5 ml10" @click="addPayType(1)">添加比例</span
              ><span class="txt-color mr10 ml10" @click="delPayType(1, index)">删除</span>
            </div>
          </el-col>
        </template>
        <!-- 方式为月度时  -->
        <template v-if="formData.payType == '1'">
          <el-col :span="12">
            <div class="contract-base-title">
              <span class="fontC-red" v-if="requiredChargeRate">
                *
              </span>
              收费比例(%)：
            </div>
            <el-input
              v-model.trim="formData.chargeRate"
              @input="onInputChargeRate($event)"
              maxlength="5"
              class="contract-base-content"
              placeholder="请输入"
              clearable
            ></el-input>
            <!-- onInput="value=value.replace(/[^\d.]/g,'')" -->
          </el-col>
          <el-col :span="12">
            <div class="contract-base-title">
              <span class="fontC-red" v-if="requiredSendTaxDeduction">
                *
              </span>
              下发扣除税点(%)：
            </div>
            <el-input
              v-model.trim="formData.sendTaxDeduction"
              @input="onInputSendTaxDeduction($event)"
              maxlength="5"
              class="contract-base-content"
              placeholder="请输入"
              clearable
            ></el-input>
            <!-- 
              onkeyup="value=value.replace(/[^\d.]/g, '')" -->
          </el-col>
          <el-col :span="12">
            <div class="contract-base-title"><span class="fontC-red">*</span>是否内扣：</div>
            <el-radio-group 
              v-model="formData.isInsideDeduction" 
              class="contract-base-content"
              :disabled="disabledInsideDeduction"
            >
              <el-radio label="Y">是</el-radio>
              <el-radio label="N">否</el-radio>
            </el-radio-group>
          </el-col>
        </template>
        <!-- 方式为季度时 -->
        <template  v-if="formData.payType == '2'">
        <el-col  :span="24" v-for="(item, index) in payTypeJsonList" :key="index">
          <div class="contract-base-title"><span class="fontC-red">*</span>回款金额(元)：</div>
          <div>
            <el-select
              v-model="item.selectType"
              style="width: 150px; margin-right: 13px"
              placeholder="请选择"
              @change="changeCheckRepeat(1, item.selectType, 'selectType', index)"
            >
              <el-option v-for="item in getCodeListByKey('季度选项')" :key="item.value" :label="item.text" :value="item.value">
              </el-option>
            </el-select>
            <el-input
              style="width: 150px"
              onkeyup="value=value.replace(/[^\d.]/g, '')"
              maxlength="12"
              v-model.trim="item.selectValue"
              placeholder="请输入"
              clearable
            ></el-input>
            <span class="txt-color mr5 ml10" @click="addPayType(2)">添加金额</span
            ><span class="txt-color mr10 ml10" @click="delPayType(2, index)">删除</span>
          </div>
        </el-col>
      </template>
        <!-- 方式为年度时 -->
        <template  v-if="formData.payType == '3'">
        <el-col :span="24" v-for="(item, index) in payTypeJsonList" :key="index">
          <div class="contract-base-title"><span class="fontC-red">*</span>回款金额(元)：</div>
          <div>
            <el-select
              v-model="item.selectType"
              style="width: 150px; margin-right: 13px"
              placeholder="请选择"
              @change="changeCheckRepeat(1, item.selectType, 'selectType', index)"
            >
              <el-option v-for="item in getCodeListByKey('年度选项')" :key="item.value" :label="item.text" :value="item.value">
              </el-option>
            </el-select>
            <el-input
              style="width: 150px"
              onkeyup="value=value.replace(/[^\d.]/g, '')"
              maxlength="12"
              v-model.trim="item.selectValue"
              placeholder="请输入"
              clearable
            ></el-input>
            <span class="txt-color mr5 ml10" @click="addPayType(3)">添加金额</span
            ><span class="txt-color mr10 ml10" @click="delPayType(3, index)">删除</span>
          </div>
        </el-col>
        </template>
      </el-row>
    </div>
    <!-- 银行信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">开户行信息</p>
      <el-row :gutter="24" v-for="(item, index) in formData.contractBankList" :key="index" class="mb20">
        <div style="text-align: right;padding-right:20px">
          <div class="add-bank-box">
            <span class="mr10" v-show="formData.contractBankList.length == index + 1" @click="addBank">添加银行</span>
            <span @click="delBank(index)">删除</span>
          </div>
        </div>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>开户银行：</div>
          <el-input
            v-model.trim="item.bankName"
            class="contract-base-content"
            :maxlength="30"
            placeholder="请输入"
            clearable
          >
            <i
              class="el-icon-plus el-input__icon"
              slot="suffix"
              @click="showCollectionBankList(item)"
            >
            </i>
          </el-input>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>开户账号：</div>
          <el-input
            @blur="changeCheckRepeat(2, item.bankAccount, 'bankAccount', index)"
            v-model.trim="item.bankAccount"
            class="contract-base-content"
            :maxlength="50"
            @input="onInput($event,index,5)"
            placeholder="请输入"
            clearable
          ></el-input>
          <!-- oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\D/g,'')" -->
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>税号：</div>
          <el-input
            v-model.trim="item.bankTaxNo"
            class="contract-base-content"
            oninput="if(/[\u4e00-\u9fa5/\s+/]|[^a-zA-Z0-9\u4E00-\u9FA5]/.test(value)) value=value.replace(/\D/g,'')"
            :maxlength="20"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red"> </span>开户行号：</div>
          <el-input
            @blur="changeCheckRepeat(2, item.bankNo, 'bankNo', index)"
            v-model.trim="item.bankNo"
            class="contract-base-content"
            oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\D/g,'')"
            :maxlength="12"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
      </el-row>
    </div>
    <!-- 签约任务 -->
    <div class="contract-base-box">
      <p class="contract-base-name">签约任务</p>
      <div class="content-main-box"  style="height:auto;" v-if="formData.contractTaskDetailList&&formData.contractTaskDetailList.length"> 
          <el-table border  stripe :data="formData.contractTaskDetailList" style="width: 682px;">
              <!-- 任务名称 -->
              <el-table-column :resizable="false" show-overflow-tooltip label="任务名称" width="180" header-align="center" align="left">
                  <template slot-scope="scope">
                      {{ scope.row.oldTaskContentName || '-' }}
                  </template>
              </el-table-column>
              <!-- 任务名称 -->
              <el-table-column :resizable="false" label="项目任务名称" width="180" header-align="center" align="left">
                <template slot-scope="scope">
                      {{ scope.row.taskContentName || '-' }}
                  </template>
              </el-table-column>
              <!-- 任务价格(元) -->
              <el-table-column :resizable="false" show-overflow-tooltip label="任务价格(元)" width="120" header-align="center" align="right">
                <template slot-scope="scope">
                    <div  v-if="scope.row.priceType==2">
                      {{  scope.row.taskPrice | numDigit }} -  {{  scope.row.maxTaskPrice | numDigit }}
                    </div>
                    <div  v-if="scope.row.priceType==1">
                      {{  scope.row.taskPrice | numDigit }}
                    </div>
                  </template>
              </el-table-column>
              <!-- 备注 -->
              <el-table-column :resizable="false" show-overflow-tooltip label="备注" width="200" header-align="center" align="left">
                  <template slot-scope="scope">
                      {{ scope.row.taskDescription || '-' }}
                  </template>
              </el-table-column>
          </el-table>
      </div>
      <!-- <el-row :gutter="24" v-for="(item, index) in formData.contractTaskDetailList" :key="index" >
        <el-col :span="24">
          <div class="contract-base-title">签约任务{{ index + 1 }}：</div>
          <el-select
            disabled
            style="width: 270px; margin-right: 10px"
            filterable
            @change="taskChange(item.templateDetailGuid, index, 'templateDetailGuid')"
            v-model="item.templateDetailGuid"
            placeholder="请选择任务"
          >
            <el-option v-for="item in taskList" :key="item.guid" :label="item.taskContentName" :value="item.guid">
            </el-option>
          </el-select>
          <el-input
            style="width: 270px; margin-right: 10px"
            disabled
            maxlength="12"
            v-model.trim="item.taskContentName"
            placeholder="请输入项目任务名称"
            clearable
          ></el-input>
          <el-input
            style="width: 270px; margin-right: 10px"
            disabled
            onkeyup="value=value.replace(/[^\d.]/g, '')"
            maxlength="12"
            v-model.trim="item.taskPrice"
            placeholder="请输入药企价格"
            clearable
          ></el-input>
          <el-input
            style="width: 346px"
            disabled
            v-model.trim="item.taskDescription"
            placeholder="备注（填写工业对该任务的个性化要求）"
            clearable
            maxlength="500"
          ></el-input>
        </el-col>
      </el-row> -->
    </div>
    <!-- 流程 -->
    <div style="padding-left: 16px; background: #fff; margin-top: 4px">
      <iframe :src="srcs" class="iframe-sty"></iframe>
    </div>
    <!-- 提交 -->
    <div class="submit-btn-box submit_btn_wrap">
      <el-button type="borderBlack" size="small" @click="$router.go(-1)">取消</el-button>
      <el-button type="borderGreen" size="small" @click="saveReq(0)">保存</el-button>
      <el-button type="importNew" size="small" @click="saveReq(1)">提交申请</el-button>
    </div>
    <!-- 选择人员 -->
    <ChoosePerson ref="choosePerson" :staffType="staffType" @onSelect="onPersonSelect"></ChoosePerson>
     <!-- 新增开户行信息弹框 start -->
    <el-dialog title="选择银行账号"  :visible.sync="bindBankDialogVisible" width="60%">
      <div class="back-color-fff form-box-add content-main-box">
        <div class="bank-list">
          <el-table
            ref="multipleTable"
            :data="bankList"
            style="width: 100%"
            border
            :height="300"
            @row-click="rowClickHandle"
            :row-key="(row) => row.guid"
            :current-row-key="selectCode"
          >
            <el-table-column align="center" width="80" label="选择">
                <template slot-scope="scope">
                  <el-radio class="radio" v-model="selectCode" :label="scope.row.guid">
                    <span></span>
                  </el-radio>
                </template>
            </el-table-column>
            <el-table-column prop="tenantName" label="银行所属公司" min-width="180" header-align="center" align="center">
              <template slot-scope="scope">
                  {{ scope.row.tenantName || '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="bankName" label="开户银行" min-width="180" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="bankAccount" label="开户账号" min-width="210" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="bankNo" label="开户行号" min-width="210" header-align="center" align="center">
              <template slot-scope="scope">
                  {{ scope.row.bankNo || '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="accountType" label="账户类型" min-width="96" header-align="center" align="center">
              <template slot-scope="scope">
                {{ $getNameByKey(scope.row.accountType, '账户类型') }}
              </template>
            </el-table-column>
            <el-table-column prop="taxpayerId" label="税号" min-width="96" header-align="center" align="center">
            </el-table-column>
          </el-table>
        </div>
        <div class="bottom-btn-box">
          <el-button type="defalut" size="small" @click="bindBankDialogVisible = false">取消</el-button>
          <!-- 新增公司开户行信息 -->
          <el-button type="primary" size="small" @click="confirmBinding()">确定</el-button>
        </div>
      </div>
      <!-- end of 开户行信息 -->
    </el-dialog>
    <!-- 新增开户行信息弹框 end -->
  </div>
</template>
<script>
import { route } from '@/api/apiRoute';
import { bpmnroute } from '@/api/apiRoute';
import store from '@/store';
import Title from '@/components/title/title.vue';
import ChoosePerson from '@/components/person/choosePerson';
export default {
  components: {
    Title,
    ChoosePerson,
  },
  data() {
    return {
      taxpayerId:'', // 关联的税号
      bankList:[],
      currentBankItem:{}, // 合同银行item
      bindBankDialogVisible:false,
      selectBank:{}, // 基础银行列表勾选的item
      selectCode:'',
      staffType: 1,
      exportUrl: `/${serverConfig.msCommonImportDataService}/import-data/import-common`,
      flowType: '00010',
      fullscreenLoading: false,
      tenantList: [], //甲方
      serviceTenantList: [], //乙方
      serviceTenantDataList: [], //服务商
      taskList: [],
      customerGuid: null,
      personGuid: null, //项目负责人
      //上传附件
      fileUrl: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      fileList: [], //上传文件列表
      invoiceModeOptions: ['先款后票', '先票后款'], //发票方式
      balanceBasisOptions: ['结算单', '结算单+运营报告', '结算单+验收报告'], //票据方式
      contractContentTypeOptions: [
        {
          text: '业务收入',
          value: '1',
        },
        {
          text: '业务支出',
          value: '2',
        },
      ],
      // 表单内容
      formData: {
        
        guid: null,
        isInput: null, //客户是否选择
        userTenantGuid: null, //当前登录人
        tenantGuid: null,
        tenantName: null, //公司名称
        contractName: null, //合同名称
        contractCode: null, //合同编码
        projectManagerName: null, //项目负责人
        projectManagerGuid: null,
        signDate: null, //签约时间
        validityDate: null, //合同有效期
        serviceTenantGuid: null, //乙方企业GUID
        serviceTenantName: null, //乙方企业名称
        enterpriseCate: null, //公司类型
        contractType: null, //合同类型
        contractContentType: null, //合同内容类型
        contractContent: null, //合同内容
        contractMoney: null, //合同金额
        invoiceMode: null, //发票方式
        payType: null, //上游付款方式
        chargeRate: null, //收费比例
        sendTaxDeduction: null, //下发扣除税点
        isInsideDeduction: 'N', //是否内扣
        isContainTax: 'N', //是否含税
        balanceBasis: null, //结算依据
        maintainCondition: null, //维保条件
        isAdvanceMoney: 'N', //是否垫资
        isSupplementAgreement: null, //是否补充协议
        contractUrl: null, //合同路径
        staffGuid: null, //申请人
        staffName: null, //申请人姓名
        isApprove: null, //是否发起审批 Y/N
        discardContractGuid: null, //待废弃合同GUID
        contractBankList: [
          {
            guid: null,
            bankName: null,
            bankAccount: null,
            bankTaxNo: null,
            bankNo: null,
          },
        ],
        contractTaskDetailList: [
          // {
          //   guid: null,
          //   templateDetailGuid: null,
          //   oldTaskContentName: null,
          //   taskContentName: null,
          //   taskPrice: null,
          //   taskDescription: null,
          // },
        ],
        contractProductList: [], //产品
        isMail: 'N',
        receiveName: null,
        receiveMobile: null,
        mailAddress: null,
        importantContent:null
      },
      contractProductList: [],
      payTypeJsonList: [
        {
          selectType: null,
          selectValue: null,
        },
      ],
      //流程
      srcs: '',
      processInstanceId: '',
      iframeSh: false,
      fileSizeTip: null,
    };
  },
  watch: {
    bindBankDialogVisible: {
      // 监听银行信息表单打开
      handler(val) {
        if (val) {
          this.selectCode = ''
        }
      },
    },
  },
  created() {
    this.fileSizeTip = serverConfig.FILE_SIZE;
    this.getFlowGuid();
    this.getTenantList();
    this.getTaskList();
    this.getServiceTenantList();
    this.getServiceTenantDataList();
    if (this.$route.query.guid) {
      this.getPageDetail();
    }
  },
  methods: {
    changeDate(flag) {
      if (flag) {
        if (this.formData.validityDate) {
          if (new Date(this.formData.signDate) > new Date(this.formData.validityDate)) {
            this.formData.signDate = null;
            this.$message.error('签约时间不能大于合同有效期！');
          }
        }
      } else {
        if (this.formData.signDate) {
          if (new Date(this.formData.signDate) > new Date(this.formData.validityDate)) {
            this.formData.validityDate = null;
            this.$message.error('合同有效期不能小于签约时间！');
          }
        }
      }
    },
    //打开选人弹框
    addPeople() {
      this.$refs.choosePerson.open([this.formData.projectManagerGuid]);
    },
    //提交所选部门
    onPersonSelect([personGuid, data, name]) {
      this.formData.projectManagerGuid = personGuid && personGuid.length > 0 ? personGuid[0] : null;
      this.formData.projectManagerName = name || null;
    },
    //获取服务商
    getServiceTenantDataList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ['9901'],
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.serviceTenantDataList = res.data.data.records || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取客户
    getTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        approveState: 'Y',
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/projectApply/list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data.records || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    onChangeContractType(val) { 
      this.formData.contractType = val;
      if (this.isPurchaseContract) {
        this.formData.chargeRate = null;
        this.formData.sendTaxDeduction = null;
      }
    },
    tenantChange(val) {
      if (val) {
        this.tenantList.forEach((i) => {
          if (i.tenantGuid == val) {
            this.formData.tenantName = i.tenantName;
            this.formData.enterpriseCate = i.platformEnterpriseType;
          }
        });
        console.log('1',this.formData.isSupplementAgreement);
        
        this.getNewContractData(val);
      } else {
        // 表单内容
        this.formData = {
          guid: this.formData.guid,
          userTenantGuid: null, //当前登录人
          tenantGuid: null,
          tenantName: null, //公司名称
          contractName: null, //合同名称
          projectManagerName: null, //项目负责人
          projectManagerGuid: null,
          contractCode: null, //合同编码
          signDate: null, //签约时间
          validityDate: null, //合同有效期
          serviceTenantGuid: null, //乙方企业GUID
          serviceTenantName: null, //乙方企业名称
          enterpriseCate: null, //公司类型
          contractType: null, //合同类型
          contractContentType: null, //合同内容类型
          contractContent: null, //合同内容
          contractMoney: null, //合同金额
          invoiceMode: null, //发票方式
          payType: null, //上游付款方式
          chargeRate: null, //收费比例
          sendTaxDeduction: null, //下发扣除税点
          isInsideDeduction: 'N', //是否内扣
          isContainTax: 'N', //是否含税
          balanceBasis: null, //结算依据
          maintainCondition: null, //维保条件
          isAdvanceMoney: 'N', //是否垫资
          isSupplementAgreement: null, //是否补充协议
          contractUrl: null, //合同路径
          staffGuid: null, //申请人
          staffName: null, //申请人姓名
          isApprove: null, //是否发起审批 Y/N
          discardContractGuid: null, //待废弃合同GUID
          contractBankList: [
            {
              guid: null,
              bankName: null,
              bankAccount: null,
              bankTaxNo: null,
              bankNo: null,
            },
          ],
          contractTaskDetailList: [
            {
              guid: null,
              templateDetailGuid: null,
              oldTaskContentName: null,
              taskContentName: null,
              taskPrice: null,
              taskDescription: null,
            },
          ],
          contractProductList: [], //产品
        };
        this.contractProductList = [];
        this.fileList = [];
        this.payTypeJsonList = [
          {
            selectType: null,
            selectValue: null,
          },
        ];
        console.log('12',this.formData.isSupplementAgreement);
      }
    },
    customerChange(val) {
      if (val) {
        this.serviceTenantDataList.forEach((i) => {
          if (i.guid == val) {
            this.formData.tenantName = i.tenantName;
          }
        });
      }
    },
    //获取乙方
    getServiceTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ['9901', '9903', '9904'],
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.serviceTenantList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    serviceTenantChange(val) {
      console.log('first', this.serviceTenantList);
      if (val) {
        this.serviceTenantList.forEach((i) => {
          if (i.guid == val) {
            this.formData.serviceTenantName = i.tenantName;
          }
        });
      }
    },
    //付款方式变化时清空其余类型的值
    changePayType(val) {
      this.formData.chargeRate = null;
      this.formData.sendTaxDeduction = null;
      this.formData.isInsideDeduction = 'N';
      this.payTypeJsonList = [{ selectType: null, selectValue: null }];
    },
    //付款信息校验
    checkPay(type) {
      try {
        this.payTypeJsonList.forEach((item) => {
          if (!item.selectType) {
            throw new Error('付款信息中选择方式不能为空');
          }
          if (!item.selectValue) {
            throw new Error('付款信息中内容不能为空');
          }
        });
        return true;
      } catch (e) {
        if (type !== 1) {
          this.$message.error(e.message);
        }
        return false;
      }
    },
    //添加付款方式
    addPayType(type) {
      if (!this.checkPay()) {
        return;
      }
      let obj = { selectType: null, selectValue: null };
      this.payTypeJsonList.push(obj);
    },
    //删除付款
    delPayType(type, index) {
      if (this.payTypeJsonList && this.payTypeJsonList.length < 2) {
        this.$message.error('至少需保留一条数据！');
        return;
      }
      this.payTypeJsonList.splice(index, 1);
    },
    contractContentTypeChange(val) {
      this.formData.contractContent = null;
    },
    contractContentTypeFocus() {
      if (!this.formData.contractContentType) {
        this.$message.error('请先选择业务类型！');
      }
    },
    //获取任务
    getTaskList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        isSuper: 'Y',
        bizState:'Y'
      };
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/template/detail/get-detail-page-list`, query)
        .then((res) => {
          self.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.taskList = res.data.data.records || [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    taskChange(val, index, name) {
      if (val) {
        this.taskList.forEach((i) => {
          if (i.guid == val) {
            this.formData.contractTaskDetailList[index].taskPrice = i.tenantTaskPrice;
            this.formData.contractTaskDetailList[index].oldTaskContentName = i.taskContentName;
            this.formData.contractTaskDetailList[index].taskContentName = i.taskContentName;
          }
        });
        this.changeCheckRepeat(3, val, name, index);
      }
    },
    // 判重 1 付款信息类  2银行信息 3签约任务
    changeCheckRepeat(type, val, fieldName, index) {
      let list = [];
      if (type == 1) {
        list = this.payTypeJsonList;
      }
      if (type == 2) {
        list = this.formData.contractBankList;
      }
      if (type == 3) {
        list = this.formData.contractTaskDetailList;
      }
      console.log('list',list);
      
      for (let i = 0; i < list.length; i++) {
        for (let j = i + 1; j < list.length; j++) {
          if (list[i][fieldName] == list[j][fieldName] && val) {
            this.$message.error('已存在该类数据，请重新填入');
            console.log('8888', list[index]);
            list[index][fieldName] = null;
          }
        }
      }
    },
    //获取公司最新合同信息
    getNewContractData(val) {
      let self = this;
      self.api.get(`/${serverConfig.msCustomerService}/contract/detail-by-tenant?tenantGuid=${val}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (res.data.data) {
            let data = res.data.data;
            data.contractCode = null;
            console.log('123',this.formData.isSupplementAgreement);
            self.getFormData(1, data);
          }else{
            //没有合同的时候，应该清空表单
            this.formData= {
              guid: null,
              isInput: null, //客户是否选择
              userTenantGuid: null, //当前登录人
              tenantGuid: null,
              tenantName: this.formData.tenantName, //公司名称
              contractName: null, //合同名称
              contractCode: null, //合同编码
              projectManagerName: null, //项目负责人
              projectManagerGuid: null,
              signDate: null, //签约时间
              validityDate: null, //合同有效期
              serviceTenantGuid: null, //乙方企业GUID
              serviceTenantName: null, //乙方企业名称
              enterpriseCate: this.formData.enterpriseCate, //公司类型
              contractType: null, //合同类型
              contractContentType: null, //合同内容类型
              contractContent: null, //合同内容
              contractMoney: null, //合同金额
              invoiceMode: null, //发票方式
              payType: null, //上游付款方式
              chargeRate: null, //收费比例
              sendTaxDeduction: null, //下发扣除税点
              isInsideDeduction: 'N', //是否内扣
              isContainTax: 'N', //是否含税
              balanceBasis: null, //结算依据
              maintainCondition: null, //维保条件
              isAdvanceMoney: 'N', //是否垫资
              isSupplementAgreement: null, //是否补充协议
              contractUrl: null, //合同路径
              staffGuid: null, //申请人
              staffName: null, //申请人姓名
              isApprove: null, //是否发起审批 Y/N
              discardContractGuid: null, //待废弃合同GUID
              contractBankList: [
                {
                  guid: null,
                  bankName: null,
                  bankAccount: null,
                  bankTaxNo: null,
                  bankNo: null,
                },
              ],
              contractTaskDetailList: [
                {
                  guid: null,
                  templateDetailGuid: null,
                  oldTaskContentName: null,
                  taskContentName: null,
                  taskPrice: null,
                  taskDescription: null,
                },
              ],
              contractProductList: [], //产品
              isMail: 'N',
              receiveName: null,
              receiveMobile: null,
              mailAddress: null,
              importantContent: null,
            }
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取详情
    getPageDetail() {
      let self = this;
      self.api.get(`/${serverConfig.msCustomerService}/contract/detail?guid=${this.$route.query.guid}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let data = res.data.data;
          this.getFormData(2, data);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //页面信息
    getFormData(type, data) {
      if (type !== 1) {
        this.customerGuid = data.isInput == 'Y' ? data.tenantGuid : null;
      }
      this.formData = {
        guid: type == 1 ? null : data.guid,
        tenantGuid: data.tenantGuid,
        tenantName: data.tenantName, //公司名称
        contractName: data.contractName, //合同名称
        contractCode: type == 1 ? null : data.contractCode, //合同编码
        signDate: data.signDate ? this.$moment(data.signDate).format('YYYY-MM-DD') : null, //签约时间
        validityDate: data.validityDate ? this.$moment(data.validityDate).format('YYYY-MM-DD') : null, //合同有效期
        serviceTenantGuid: data.serviceTenantGuid ? data.serviceTenantGuid : data.serviceTenantName, //乙方企业GUID
        serviceTenantName: data.serviceTenantName, //乙方企业名称
        projectManagerName: data.projectManagerName, //项目负责人
        projectManagerGuid: data.projectManagerGuid,
        enterpriseCate: data.enterpriseCate, //公司类型
        contractType: data.contractType, //合同类型
        contractContentType: data.contractContentType, //合同内容类型
        contractContent: data.contractContent, //合同内容
        contractMoney: data.contractMoney, //合同金额
        invoiceMode: data.invoiceMode, //发票方式
        payType: data.payType, //上游付款方式
        chargeRate: data.chargeRate, //收费比例
        sendTaxDeduction: data.sendTaxDeduction, //下发扣除税点
        isInsideDeduction: data.isInsideDeduction, //是否内扣
        isContainTax: data.isContainTax, //是否含税
        balanceBasis: data.balanceBasis, //结算依据
        maintainCondition: data.maintainCondition, //维保条件
        isAdvanceMoney: data.isAdvanceMoney, //是否垫资
        isSupplementAgreement: type == 1 ? null : data.isSupplementAgreement, //是否补充协议
        contractUrl: data.contractUrl, //合同路径
        staffGuid: data.staffGuid, //申请人
        staffName: data.staffName, //申请人姓名
        isApprove: data.isApprove, //是否发起审批 Y/N
        contractBankList: data.contractBankList || [
          {
            guid: null,
            bankName: null,
            bankAccount: null,
            bankTaxNo: null,
            bankNo: null,
          },
        ],
        contractTaskDetailList: data.contractTaskDetailList || [
          {
            guid: null,
            templateDetailGuid: null,
            oldTaskContentName: null,
            taskContentName: null,
            taskPrice: null,
            taskDescription: null,
          },
        ],
        contractProductList: [],
        isMail:type == 1? 'N':data.isMail,
        receiveName:type == 1? null:data.receiveName,
        receiveMobile:type == 1? null:data.receiveMobile,
        mailAddress: type == 1? null:data.mailAddress,
        importantContent: data.importantContent

      };
      //带出/回显产品与用户已勾选合并、按productGuid去重：编辑回显时选中框初始为空等效直接回显；切换甲方不清空手选、带出项不重复
      if (data.contractProductList && data.contractProductList.length > 0) {
        data.contractProductList.forEach((k) => {
          if (this.contractProductList.indexOf(k.productGuid) === -1) {
            this.contractProductList.push(k.productGuid);
          }
        });
      }
      if (data.payType !== '1' && data.payTypeJson) {
        this.payTypeJsonList = JSON.parse(data.payTypeJson);
      }
      if (this.formData.contractUrl) {
        this.fileList = JSON.parse(this.formData.contractUrl);
      }
      console.log('12345',this.formData.isSupplementAgreement);
    },
    onInputChargeRate(val) {
      if (this.isPurchaseContract) {
        this.formData.isInsideDeduction = 'N';
        this.formData.sendTaxDeduction = null;
      }
    },
    onInputSendTaxDeduction(val) {
      if (this.isPurchaseContract) {
        this.formData.isInsideDeduction = 'Y';
        this.formData.chargeRate = null;
      }
    },
    // 开户账号校验
    onInput(event,idx,flg) { 
      const newValue = event; 
      let regular=/\D/g
      if(flg==1||flg==2){
        regular=/[^\d.]/g
      }
      const numericValue = newValue.replace(regular, ''); // 仅保留数字 
      // 检查输入是否包含非数字字符 
      if (newValue !== numericValue) { 
        // 如果有非数字字符，则更新输入框的值为仅包含数字的值
        if(flg==1){
          this.$set(this.formData,'chargeRate',numericValue)
          
        }else if(flg==5){
          this.$set(this.formData.contractBankList[idx],'bankAccount',numericValue)
        }else if(flg==2){
          this.$set(this.formData,'sendTaxDeduction',numericValue)
        }
        
        
        
        //  this.inputValue = numericValue; 
        } else { 
          // 如果输入内容只包含数字，则保持输入框的当前值不变 
          if(flg==1){
            this.$set(this.formData,'chargeRate',newValue)
          }else if(flg==5){
            this.$set(this.formData.contractBankList[idx],'bankAccount',newValue)
          }else if(flg==2){
            this.$set(this.formData,'sendTaxDeduction',newValue)
          }
          
          // this.inputValue = newValue; 
        } 
    },
    //银行信息校验
    checkBank(type) {
      try {
        this.formData.contractBankList.forEach((item) => {
          console.log('item',item);
          
          if (!item.bankName) {
            throw new Error('银行信息中开户银行不能为空');
          }
          if (!item.bankAccount) {
            throw new Error('银行信息中开户账号不能为空');
          }
          if (!item.bankTaxNo) {
            throw new Error('银行信息中税号不能为空');
          }
          // if (!item.bankNo) {
          //   throw new Error('银行信息中开户行号不能为空');
          // }
        });
        return true;
      } catch (e) {
        if (type !== 1) {
          this.$message.error(e.message);
        }
        return false;
      }
    },
    //添加银行信息
    addBank() {
      if (!this.checkBank()) {
        return;
      }
      let item = { guid: null, bankName: null, bankAccount: null, bankTaxNo: null, bankNo: null };
      this.formData.contractBankList.push(item);
    },
    //删除银行信息
    delBank(index) {
      if (this.formData.contractBankList && this.formData.contractBankList.length == 1) {
        this.$message.error('至少需有一条银行信息！');
        return;
      }
      this.formData.contractBankList.splice(index, 1);
    },
    checkSigning(type) {
      try {
        this.formData.contractTaskDetailList.forEach((item) => {
          if (!item.templateDetailGuid) {
            throw new Error('签约任务中任务不能为空');
          }
          if (!item.oldTaskContentName) {
            throw new Error('签约任务中项目任务名称不能为空');
          }
          if (!item.taskPrice) {
            throw new Error('签约任务中价格不能为空');
          }
          // if (!item.taskDescription) {
          //   throw new Error('签约任务中备注不能为空');
          // }
        });
        return true;
      } catch (e) {
        if (type !== 1) {
          this.$message.error(e.message);
        }
        return false;
      }
    },
    //添加签约任务
    addSigning() {
      if (!this.checkSigning()) {
        return;
      }
      let item = {
        guid: null,
        templateDetailGuid: null,
        taskContentName: null,
        oldTaskContentName: null,
        taskPrice: null,
        taskDescription: null,
      };
      this.formData.contractTaskDetailList.push(item);
    },
    //删除签约任务
    delSigning(index) {
      if (this.formData.contractTaskDetailList && this.formData.contractTaskDetailList.length == 1) {
        this.$message.error('至少需有一条签约任务信息！');
        return;
      }
      this.formData.contractTaskDetailList.splice(index, 1);
    },
    checkForm() {
      if (!this.formData.contractType) {
        this.$message.error('合同类型不能为空');
        return false;
      }
      if (!this.formData.contractName) {
        this.$message.error('合同名称不能为空');
        return false;
      }
      // if (!this.formData.projectManagerName) {
      //   this.$message.error('运营经理不能为空');
      //   return false;
      // }
      if (!this.formData.signDate) {
        this.$message.error('签约时间不能为空');
        return false;
      }
      if (!this.formData.validityDate) {
        this.$message.error('有效期至不能为空');
        return false;
      }
      if (!this.formData.tenantName) {
        this.$message.error('甲方名称不能为空');
        return false;
      }
      if (!this.formData.serviceTenantName) {
        this.$message.error('乙方名称不能为空');
        return false;
      }
      if (!this.formData.enterpriseCate) {
        this.$message.error('公司类型不能为空');
        return false;
      }
      if (!this.formData.contractContentType) {
        this.$message.error('业务类型不能为空');
        return false;
      }
      if (!this.formData.contractContent) {
        this.$message.error('业务类型内容不能为空');
        return false;
      }
      // if (!this.formData.contractMoney) {
      //   this.$message.error('合同金额不能为空');
      //   return false;
      // }
      if (!this.formData.invoiceMode) {
        this.$message.error('发票方式不能为空');
        return false;
      }
      if (!this.formData.balanceBasis) {
        this.$message.error('结算依据不能为空');
        return false;
      }
      if (!this.formData.maintainCondition) {
        this.$message.error('维保条件不能为空');
        return false;
      }
      if (!this.formData.isContainTax) {
        this.$message.error('任务价格是否含税不能为空');
        return false;
      }
      if (!this.formData.isAdvanceMoney) {
        this.$message.error('是否垫资不能为空');
        return false;
      }
      if (!this.formData.isMail) {
        this.$message.error('是否邮寄不能为空');
        return false;
      }
      if (!this.formData.isSupplementAgreement) {
        this.$message.error('是否补充协议不能为空');
        return false;
      }
      if (this.formData.isMail == 'Y' && !this.formData.receiveName) {
        this.$message.error('收件人姓名不能为空');
        return false;
      }
      if (this.formData.isMail == 'Y' && !this.formData.receiveMobile) {
        this.$message.error('收件人电话不能为空');
        return false;
      }
      if (this.formData.isMail == 'Y' && !this.formData.mailAddress) {
        this.$message.error('邮寄地址不能为空');
        return false;
      }
      if (!this.fileList.length) {
        this.$message.error('合同附件不能为空');
        return false;
      }
      if (!this.formData.importantContent) {
        this.$message.error('合同重点内容说明不能为空');
        return false;
      }
      if (!this.contractProductList.length) {
        this.$message.error('产品信息不能为空');
        return false;
      }
      if (!this.formData.payType) {
        this.$message.error('付款方式不能为空');
        return false;
      }
      console.log('1',this.formData.chargeRate,this.formData.chargeRate!=0);
      
      if (!this.formData.chargeRate && this.formData.chargeRate != 0 && this.formData.payType == '1' && !this.isPurchaseContract) {
        this.$message.error('收费比例不能为空');
        return false;
      }
      console.log('2',this.formData.sendTaxDeduction,this.formData.sendTaxDeduction!=0);
      if (!this.formData.sendTaxDeduction && this.formData.sendTaxDeduction != 0 && this.formData.payType == '1' && this.formData.isInsideDeduction == 'Y' && !this.isPurchaseContract) {
        this.$message.error('下发扣除税点不能为空');
        return false;
      }
      // 是采购合同 && 是月度付款 && 收费比例 && 下发扣除税点为空
      if (
        this.isPurchaseContract &&
        this.formData.payType == "1" &&
        !this.formData.chargeRate &&
        !this.formData.sendTaxDeduction
      ) {
        this.$message.error("请填写收费比例或下发扣除税点");
        return false;
      }
      if (
        this.isPurchaseContract &&
        this.formData.payType == "1" &&
        this.formData.chargeRate &&
        this.formData.sendTaxDeduction
      ) {
        this.$message.error("收费比例与下发扣除税点不能同时填写");
        return false;
      }
      if (!this.formData.isInsideDeduction && this.formData.payType == '1') {
        this.$message.error('是否内扣不能为空');
        return false;
      }
      if (!this.checkPay(1) && this.formData.payType !== '1') {
        this.$message.error('付款信息不能为空');
        return false;
      }
      if (!this.checkBank(1)) {
        this.$message.error('银行信息不能为空');
        return false;
      }
      return true;
    },
    //提交申请 type为1时提交0保存
    saveReq(type) {
      //甲方处理
      this.formData.tenantGuid = this.customerGuid ? this.customerGuid : this.formData.tenantGuid;
      this.formData.isInput = this.customerGuid ? 'Y' : 'N';//判断是否选择客户
      //乙方手输时guid为空
      const flg = this.serviceTenantList.findIndex((item) => {
        return item.guid == this.formData.serviceTenantGuid;
      });
      this.formData.serviceTenantName = flg == -1 ? this.formData.serviceTenantGuid : this.formData.serviceTenantName;
      this.formData.serviceTenantGuid = flg == -1 ? null : this.formData.serviceTenantGuid;
      if (type == 1 && !this.checkForm()) {
        return;
      } else if (!this.formData.tenantGuid) {
        this.$message.error('甲方名称不能为空');
        return false;
      }
      if (this.formData.payType == '1') {
        this.formData.payTypeJson = null;
      } else {
        this.formData.payTypeJson = JSON.stringify(this.payTypeJsonList);
        this.formData.chargeRate = null;
        this.formData.sendTaxDeduction = null;
        this.formData.isInsideDeduction = null;
      }
      let list = this.getCodeListByKey('传世产品线');
      //每次提交基于当前勾选重建产品数组，防止后端校验失败重试时数组累积导致产品重复入库
      this.formData.contractProductList = [];
      list.forEach((m) => {
        this.contractProductList.forEach((n) => {
          if (m.value == n) {
            this.formData.contractProductList.push({ productName: m.text, productGuid: m.value });
          }
        });
      });
      let userinfo = JSON.parse(localStorage.userInfo);
      let form = this.formData;
      
      if (form.contractTaskDetailList.length > 0) {
        form.contractTaskDetailList.forEach((item,idx)=>{
          if( !item.templateDetailGuid  ){
            //没有签约任务，删除对象
            form.contractTaskDetailList.splice(idx,1);
          }
        })
      }
      if (this.fileList && this.fileList.length > 0) {
        form.contractUrl = JSON.stringify(this.fileList);
      }
      form.staffGuid = userinfo.staffGuid;
      form.staffName = userinfo.staffName;
      // form.currentTenantGuid = userinfo.tenantGuid;
      form.isApprove = type == 1 ? 'Y' : 'N';//是否发起审批
      if (this.$route.query.toType == 3) {//重新提交
        form.guid = null;
        form.discardContractGuid = this.$route.query.guid;
      }
      this.fullscreenLoading = true;
      if (form.chargeRate === '') {
        form.chargeRate = null; // 空串的时候 后端要 null
      }
      if(form.sendTaxDeduction === ''){
        form.sendTaxDeduction = null; // 空串的时候 后端要 null
      }
      form.userTenantGuid = localStorage.guid;
      this.api
        .postJson(`/${serverConfig.msCustomerService}/contract/save`, form)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message({
              message: '提交成功',
              type: 'success',
            });
            this.$router.go(-1);
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          this.fullscreenLoading = false;
        });
    },
    //获取流程Guid
    getFlowGuid() {
      let self = this;
      let userInfo = JSON.parse(localStorage.userInfo);
      let req = {
        tenantGuid: localStorage.guid,
        flowType: this.flowType,
        staffGuid: userInfo.staffGuid,
      };
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/get-camunda-deployment-id`, req)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
              self.iframeSh = true;
              self.srcs =
                bpmnroute + '/iframeBpmn?camundaDeploymentId=' + res.data.data + '&token=' + localStorage.token;
              console.log(self.srcs);
            } else {
              self.$message.error(messageConfig.FLOW_NO_ID);
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //上传文件
    uploadFile(file) {
      let self = this;
      self.fullscreenLoading = true;
      let formData = new FormData();
      formData.append('file', file.file);
      // /[!@#$%^&*()_+\-=\[\]{}|;:'",<>\/?]/g
      formData.append('fileName', file.file.name?.replace(/[#+%]/g, ""));
      self.api
        .postImage(self.fileUrl, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: file.file.name?.replace(/[#+%]/g, ""),
              path: res.data.data.data,
            };
            self.fileList.push(item);
            self.fullscreenLoading = false;
            self.$message({
              message: '上传成功',
              type: 'success',
            });
          } else {
            self.fileList = [];
            self.$message.error('上传失败!');
          }
        })
        .catch(() => {
          self.$message('上传失败！');
        });
    },
    //上传限制
    beforeAvatarUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message({
          message: `上传文件大小不能超过 20MB!`,
          type: 'warning',
        });
      }
      return isLt2M;
    },
    //移除文件
    handleFileRemove(file) {
      let self = this;
      console.log(file.url);
      self.fileList.forEach(function (i, index) {
        if (i.path == file.path) {
          self.fileList.splice(index, 1);
        }
      });
    },
    handleExceed(files, fileList) {
      // this.fileList = [];
      this.$message.warning(
        `当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`,
      );
    },
    // todo 合同信息绑定银行账号
    confirmBinding() {
      this.currentBankItem.bankAccount = this.selectBank.bankAccount
      this.currentBankItem.bankName = this.selectBank.bankName
      this.currentBankItem.accountType = this.selectBank.accountType
      this.currentBankItem.bankTaxNo = this.selectBank.taxpayerId
      this.currentBankItem.guid = this.selectBank.guid
      this.bindBankDialogVisible = false
    },
    // 获取收款方银行账户列表
    showCollectionBankList(itemBank) {
      let guid = ''
      let { contractType } = this.formData
      if (contractType && contractType === '2') { // 采购合同, 取乙方银行卡
        if (this.formData.serviceTenantGuid) {
          guid = this.formData.serviceTenantGuid
        } else {
          this.$message.warning('请选择公司')
          return
        }
      } else if (contractType){ // 其他类型合同,取甲方银行卡
         if (this.formData.tenantGuid || this.customerGuid) {
          guid = this.formData.tenantGuid || this.customerGuid
        } else {
          this.$message.warning('请选择公司')
          return
        }
      } else {
        this.$message.warning('请选择合同类型')
        return
      }
      this.currentBankItem = itemBank
      this.bindBankDialogVisible = true;
      this.getBankList(guid);
    },
    // todo 获取企业基础银行列表
    // 1.如果是药企-服务商合同, 银行是药企 2.如果是服务商-代征公司, 银行是代征公司
    getBankList(guid) {
      
      this.api
        .get(`/${serverConfig.msCustomerService}/tenant/get-tenant-invoice-list?tenantGuid=${guid}&bizState=Y`)
        .then((res) => {
          const { data } = res;
          if (data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let datas = data.data;
            //开户行信息
            if (datas && datas.length) {
              this.$set(this, 'bankList', datas);
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    // 拿到勾选的值
    handleSelectionChange(val) {
      this.selectBank = val;
    },
    // 选择对应的收款方和银行信息
    rowClickHandle(row) {
        this.selectCode = row.guid;
        let bankItem = this.bankList.find((item) => item.guid === row.guid);
        this.selectBank = bankItem;
    }
  },
  computed: {
    /***是否是采购合同 */
    isPurchaseContract() {
      return this.formData.contractType === '2'
    },
    disabledInsideDeduction() {
      // 是否是采购合同
      return this.isPurchaseContract
    },
    /**收费比例 必填 */
    requiredChargeRate() {
      if (!this.isPurchaseContract) {
        return true
      }
      return this.formData.isInsideDeduction == 'N'
    },
    /**下发扣除税点 必填 */
    requiredSendTaxDeduction() {
      // if (!this.isPurchaseContract) {
      //   return false
      // }
      return this.formData.isInsideDeduction == 'Y'
    }
  },
};
</script>
<style scoped>
.contract-information-page {
  overflow: auto;
}
.contract-base-box {
  padding: 20px 16px;
  margin-top: 4px;
  background: #fff;
}
.contract-base-name {
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin: 8px 0 20px 0;
}
.contract-base-box .el-col-12,
.contract-base-box .el-col-24,
.contract-base-box .el-col-7,
.contract-base-box .el-col-6 {
  min-height: 37px;
  display: flex;
  /* align-items: center; */
  margin-bottom: 8px;
  padding-right: 20px;
  box-sizing: border-box;
}
.contract-base-title {
  flex-shrink: 0;
  width: 145px;
  line-height: 36px;
  text-align: right;
  font-size: 14px;
}
.contract-base-content {
  width: 314px;
  text-align: left;
  line-height: 36px;
}
/deep/.el-radio-group {
  padding-top: 5px !important;
}
/* 添加银行 */
.add-bank-box {
  color: #4fa1a4;
  margin-left: 15px;
  line-height: 36px;
}
.add-bank-box span {
  cursor: pointer;
}
.iframe-sty {
  width: 100%;
  height: 500px;
  border: none;
  /* background:grey; */
}
.submit-btn-box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  border-top: 1px solid #d9d9d9;
  background: #fff;
}
.content-main-box {
  height: 100%;
}
.bottom-btn-box {
   padding: 18px 0px;
  text-align: center;
  border-top: 1px solid #e5e5e5;
}
/deep/ .el-dialog__body {
  height: 370px;
  padding: 0 20px;
}
</style>
